// Watches real add-to-cart buttons (product-to-cart web component) and shows a
// brief success checkmark right after the theme's own loading spinner (the
// "!loading" class) finishes, without touching the underlying cart logic.
(function () {
  function flashSuccess(btn) {
    btn.classList.add('atc-anim', 'is-success');
    setTimeout(function () {
      btn.classList.remove('is-success');
    }, 900);
  }

  function watch(btn) {
    if (!btn || btn.dataset.atcWatched) return;
    btn.dataset.atcWatched = 'true';
    var wasLoading = false;
    var observer = new MutationObserver(function () {
      var isLoading = btn.classList.contains('!loading');
      if (isLoading) {
        wasLoading = true;
      } else if (wasLoading) {
        wasLoading = false;
        flashSuccess(btn);
      }
    });
    observer.observe(btn, { attributes: true, attributeFilter: ['class'] });
  }

  function scan(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('[data-element="to-cart-button"]').forEach(watch);
  }

  document.addEventListener('DOMContentLoaded', function () {
    scan(document);
    var bodyObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes && m.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches('[data-element="to-cart-button"]')) watch(node);
          scan(node);
        });
      });
    });
    bodyObserver.observe(document.body, { childList: true, subtree: true });
  });
})();
